import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml' })
export class SafeHtml implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(code) {
    return this.sanitizer.bypassSecurityTrustHtml(code);
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/safe-html/safe-html.pipe.ts